import { SettingsPermissions } from "@redotech/account-common/permissions";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { breadcrumbSlot } from "@redotech/redo-web/breadcrumb";

const attributeDefinitionsBreadcrumb = breadcrumbSlot();

export const productSettingsRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      breadcrumb: "Attribute Definitions",
      permission: SettingsPermissions.SET_GENERAL_SETTINGS,
    },
    path: "attributes",
    children: [
      {
        index: true,
        lazy: async () => {
          const { AttributeDefinitionsLandingPage } =
            await import("../../../../setting/attribute-definitions");
          return { Component: AttributeDefinitionsLandingPage };
        },
      },
      {
        handle: {
          breadcrumb: attributeDefinitionsBreadcrumb,
          permission: SettingsPermissions.SET_GENERAL_SETTINGS,
        },
        path: ":ownerType",
        async lazy() {
          const { AttributeDefinitionsPage } =
            await import("../../../../setting/attribute-definitions");
          return {
            element: (
              <AttributeDefinitionsPage
                breadcrumb={attributeDefinitionsBreadcrumb}
              />
            ),
          };
        },
      },
    ],
  },
  {
    handle: {
      breadcrumb: "Products",
      permission: SettingsPermissions.SET_GENERAL_SETTINGS,
    },
    path: "products",
    async lazy() {
      const { ProductPage } =
        await import("../../../../setting/product/product");
      return { Component: ProductPage };
    },
  },
];
